var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11630.014 -9127.044)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.732,
    cy: 18.732,
    rx: 18.732,
    ry: 18.732,
    transform: "translate(11630.014 9163.669) rotate(-77.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.261,21.976a10.222,10.222,0,0,1-2.336.654c.374-.047.934-.747,1.168-1.028a5.18,5.18,0,0,0,.794-1.4c0-.047.047-.093,0-.14h-.14a14.06,14.06,0,0,1-2.756,1.074c-.093,0-.14,0-.187-.047-.093-.093-.14-.187-.234-.234a6.61,6.61,0,0,0-1.355-.841,4.434,4.434,0,0,0-2.055-.327,5.025,5.025,0,0,0-3.55,1.869,4.413,4.413,0,0,0-.934,1.869,5.779,5.779,0,0,0-.047,2.009c0,.093,0,.14-.093.093a14.7,14.7,0,0,1-9.53-4.811q-.14-.21-.28,0a4.816,4.816,0,0,0,.841,5.7,3.216,3.216,0,0,0,.607.514,5.075,5.075,0,0,1-1.822-.514c-.093-.093-.187-.047-.187.093a2.469,2.469,0,0,0,.047.561,4.946,4.946,0,0,0,2.99,3.877,3.022,3.022,0,0,0,.607.187,5.009,5.009,0,0,1-1.822.047c-.14-.047-.187.047-.14.187a5.152,5.152,0,0,0,3.784,3.176c.187.047.327.047.514.093l-.047.047c-.42.654-1.915,1.121-2.569,1.355a9.4,9.4,0,0,1-3.924.514c-.234-.047-.234-.047-.327,0-.047.047,0,.093.047.14.28.187.561.327.794.467a11.273,11.273,0,0,0,2.616,1.028,13.937,13.937,0,0,0,13.547-3.176c2.8-2.756,3.737-6.587,3.737-10.37,0-.14.187-.234.28-.327A10.083,10.083,0,0,0,38.121,22.4a.435.435,0,0,0,.093-.374h0C38.354,21.929,38.354,21.929,38.261,21.976Z",
    transform: "translate(11625.407 9120.079)",
    fill: "#313830"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.ff61dccea6ceea1a2c2da1cdf6b45793.svg";
export { ForwardRef as ReactComponent };